/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Ship Icon component.
 */
export const AssetShipIcon = (props: IconProps) => {
  const {color, size = IconSize.large} = props;
  const {iconSize, iconColor} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d="M3.82031 11.0225C3.82031 10.7463 4.04417 10.5225 4.32031 10.5225H13.5456C13.8217 10.5225 14.0456 10.7463 14.0456 11.0225V12.4465C14.0456 12.7226 13.8217 12.9465 13.5456 12.9465H4.32031C4.04417 12.9465 3.82031 12.7226 3.82031 12.4465V11.0225Z" fill={iconColor}/>
      <path d="M5.41064 5.79688C5.41064 5.52073 5.6345 5.29688 5.91064 5.29688H7.03141C7.30755 5.29688 7.53141 5.52073 7.53141 5.79688V9.3035C7.53141 9.57964 7.30755 9.8035 7.03141 9.8035H5.91064C5.6345 9.8035 5.41064 9.57964 5.41064 9.3035V5.79688Z" fill={iconColor}/>
      <path d="M10.3706 7.68945C10.3706 7.41331 10.5945 7.18945 10.8706 7.18945H11.9914C12.2675 7.18945 12.4914 7.41331 12.4914 7.68945V9.30224C12.4914 9.57838 12.2675 9.80224 11.9914 9.80224H10.8706C10.5945 9.80224 10.3706 9.57838 10.3706 9.30224V7.68945Z" fill={iconColor}/>
      <path d="M17.0614 11.3936C16.9244 11.3936 16.7934 11.4498 16.699 11.549L14.7986 13.5478C14.7042 13.6471 14.5732 13.7033 14.4362 13.7033H2.05538C1.72425 13.7033 1.48458 14.0194 1.57393 14.3382L2.69456 18.3368C2.75505 18.5527 2.95183 18.7019 3.17601 18.7019H19.3123C19.5161 18.7019 19.6995 18.5782 19.7759 18.3893L22.3259 12.0809C22.4588 11.7523 22.2168 11.3936 21.8623 11.3936H17.0614Z" fill={iconColor}/>
    </svg>
  );
};

export default AssetShipIcon;
